import { render, staticRenderFns } from "./EditPPage.vue?vue&type=template&id=36a943d2&scoped=true&"
import script from "./EditPPage.vue?vue&type=script&lang=js&"
export * from "./EditPPage.vue?vue&type=script&lang=js&"
import style0 from "./EditPPage.vue?vue&type=style&index=0&id=36a943d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a943d2",
  null
  
)

export default component.exports